export const EMPTY_PRINT_VALUE = "—";

export const formatPrintText = (value?: string | null) => {
    const text = value?.trim();

    return text || EMPTY_PRINT_VALUE;
};

export const formatPrintStatus = (value?: string | null) => {
    const text = value?.trim();

    if (!text) return EMPTY_PRINT_VALUE;

    const words = text.replace(/_/g, " ").toLowerCase();

    return words.charAt(0).toUpperCase() + words.slice(1);
};

export const formatPrintNativeLanguage = (code?: string | null) => {
    const languageCode = code?.trim();

    if (!languageCode) return EMPTY_PRINT_VALUE;

    try {
        const displayName = new Intl.DisplayNames([languageCode], {type: "language"}).of(languageCode);

        return displayName || languageCode;
    } catch {
        return languageCode;
    }
};
